export { default as PulseSolidAltIcon } from './PulseSolidAltIcon';
